var map = {
	"./ancillary-order-details/ancillary-order-details.module.ngfactory": [
		"./src/app/core/pages/orders/ancillary-order-details/ancillary-order-details.module.ngfactory.js",
		"common",
		"ancillary-order-details.module"
	],
	"./auth/auth.module.ngfactory": [
		"./src/app/auth/auth.module.ngfactory.js",
		"auth.module"
	],
	"./card-operations/dreamFolks-lounge-renewal-order-details/dreamFolks-lounge-renewal-order-details.module.ngfactory": [
		"./src/app/core/pages/admin/card-operations/dreamFolks-lounge-renewal-order-details/dreamFolks-lounge-renewal-order-details.module.ngfactory.js",
		"common",
		"dreamFolks-lounge-renewal-order-details.module"
	],
	"./components/rate/rate-table/rate-table.module.ngfactory": [
		"./src/app/core/components/rate/rate-table/rate-table.module.ngfactory.js",
		"common",
		"rate-table.module"
	],
	"./orders-details/orders-details.module.ngfactory": [
		"./src/app/core/pages/orders/orders-details/orders-details.module.ngfactory.js",
		"common",
		"orders-details.module"
	],
	"./pages/admin/admin.module.ngfactory": [
		"./src/app/core/pages/admin/admin.module.ngfactory.js",
		"admin.module",
		"common"
	],
	"./pages/card-distribution/card-distribution.module.ngfactory": [
		"./src/app/core/pages/card-distribution/card-distribution.module.ngfactory.js",
		"common",
		"card-distribution.module"
	],
	"./pages/card/card.module.ngfactory": [
		"./src/app/core/pages/card/card.module.ngfactory.js",
		"common",
		"card.module"
	],
	"./pages/dashboard/dashboard.module.ngfactory": [
		"./src/app/core/pages/dashboard/dashboard.module.ngfactory.js",
		"common",
		"dashboard.module"
	],
	"./pages/default/blank/blank.module.ngfactory": [
		"./src/app/core/pages/default/blank/blank.module.ngfactory.js",
		"blank.module"
	],
	"./pages/fxc-management/fxc-management.module.ngfactory": [
		"./src/app/core/pages/fxc-management/fxc-management.module.ngfactory.js",
		"common",
		"fxc-management.module"
	],
	"./pages/leads/leads.module.ngfactory": [
		"./src/app/core/pages/leads/leads.module.ngfactory.js",
		"common",
		"leads.module"
	],
	"./pages/orders/orders.module.ngfactory": [
		"./src/app/core/pages/orders/orders.module.ngfactory.js",
		"common",
		"orders.module"
	],
	"./pages/payment/payment.module.ngfactory": [
		"./src/app/core/pages/payment/payment.module.ngfactory.js",
		"common",
		"payment.module"
	],
	"./pages/quick-actions/quick-actions.module.ngfactory": [
		"./src/app/core/pages/quick-actions/quick-actions.module.ngfactory.js",
		"common",
		"quick-actions.module"
	],
	"./pages/remittance-management/remittance-management.module.ngfactory": [
		"./src/app/core/pages/remittance-management/remittance-management.module.ngfactory.js",
		"common",
		"remittance-management.module"
	],
	"./reports/reports.module.ngfactory": [
		"./src/app/core/pages/admin/reports/reports.module.ngfactory.js",
		"common",
		"reports.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main